import React from 'react';
import { UserAchievementCard } from '../Achievements/Components/UserAchievementCard';
import LoadingIcon from '../Components/LoadingIcon';
import { useAchievements } from '../Context/AchievementsProvider';
import { StatsSection } from './StatsSection';
import { XPLevelSection } from './XPLevelSection';

export default function MyStatsView() {
  const { maxUserAchievements } = useAchievements();
  if (!maxUserAchievements) {
    return <LoadingIcon fullScreen />;
  }

  return (
    <div className="relative w-full h-full flex-1 overflow-hidden">
      <div className="w-full h-full flex flex-row justify-center max-sm:py-0">
        <div className="flex flex-col space-y-8 w-full max-w-7xl px-6 py-6 max-sm:px-4">
          <div className="flex flex-col lg:flex-row gap-8">
            <div className="flex-1 lg:w-2/3 h-full">
              <div className="h-full">
                <XPLevelSection />
              </div>
            </div>
            <div className="h-full">
              <div className="h-full">
                <StatsSection />
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-4">
            <h2 className="text-2xl text-left font-semibold text-neutral-800">
              Badges
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {maxUserAchievements
                ?.sort(
                  (a, b) =>
                    10000 * (a.tier - b.tier) +
                    1 * (a.unitsProgress - b.unitsProgress),
                )
                ?.map((userAchievement) => (
                  <UserAchievementCard
                    key={userAchievement.id}
                    userAchievement={userAchievement}
                  />
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
